<script lang="ts" setup>
import preventPageScrolling from '@/helpers/preventPageScrolling';

const value = defineModel<boolean>({ default: false });

const emit = defineEmits<{
  close: [void];
}>();

const closeModal = function closeModal() {
  value.value = false;

  emit('close');
};

const { allowScroll, preventScroll } = preventPageScrolling();

watch(
  () => value.value,
  (newVal) => {
    if (newVal) {
      preventScroll();
    } else {
      allowScroll();
    }
  },
);
</script>

<template>
  <div
    class="base-modal"
    :class="{ 'base-modal--open': value }"
  >
    <div
      class="base-modal__backdrop"
      @click.stop="closeModal"
    ></div>

    <div class="base-modal__wrap">
      <div class="base-modal__content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.base-modal {
  $this: 'base-modal';

  position: fixed;
  z-index: 5998;
  border-radius: 0 !important;
  max-width: 100vw;
  max-height: 100vh;
  pointer-events: none !important;
  inset: 0;

  &--open {
    .#{$this}__backdrop {
      opacity: 1;
      pointer-events: all;
    }

    .#{$this}__wrap {
      top: 50%;
      transform: translate(-50%, -50%);
      pointer-events: all;
    }
  }

  &__backdrop {
    position: fixed;
    z-index: 5999;
    pointer-events: none;
    outline: 0;
    background: rgba(#222e3a, 0.5);
    inset: 0;
    transition: opacity $anim-primary;
    opacity: 0;
  }

  &__wrap {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: 16px;
    padding: 16px;
    pointer-events: none;
    position: fixed;
    top: 100%;
    left: 50%;
    z-index: 6000;
    background-color: $color-white;
    max-height: calc(100vh - 96px);
    transition: transform $anim-primary;
    transform: translate(-50%, 100%);
  }

  &__content {
    overflow: auto;
    padding-inline: 16px;
  }
}
</style>
